module.exports = __webpack_public_path__ + "assets/img/play-store.48182507.svg";